import m from "./../../../dist/es2015/locales/cs_CZ.js";
export const am5locales_cs_CZ = m;